export const noteActions = Object.freeze({
  SET_CONTENT: 'SET_CONTENT',
  SET_STYLE: 'SET_STYLE',
  SET_STATUS: 'SET_STATUS',
  SET_PINNED: 'SET_PINNED',
  SET_TAGS: 'SET_TAGS',
  SET_PRIORITY: 'SET_PRIORITY',
  RESET: 'RESET',
});

export const noteStatus = Object.freeze({
  ACTIVE: 'ACTIVE',
  ARCHIVE: 'ARCHIVE',
  TRASH: 'TRASH',
});
